import { render, staticRenderFns } from "./q-pop-read-card.vue?vue&type=template&id=ffc29f04&scoped=true&"
import script from "./q-pop-read-card.vue?vue&type=script&lang=js&"
export * from "./q-pop-read-card.vue?vue&type=script&lang=js&"
import style0 from "./q-pop-read-card.vue?vue&type=style&index=0&id=ffc29f04&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc29f04",
  null
  
)

export default component.exports